import { useState } from 'react';

const isEmpty = (value: unknown) =>
  value === undefined ||
  value === null ||
  value === '' ||
  (Array.isArray(value) && value.length === 0);

/**
 * Counts the writes that empty each filter. A widget holding text it has not
 * written yet watches its count, so Clear all reaches it even when the stored
 * value was already empty.
 */
export const useFilterClears = () => {
  const [clearCounts, setClearCounts] = useState<Record<string, number>>({});
  const noteWrite = (id: string, value: unknown) => {
    if (isEmpty(value)) {
      setClearCounts((counts) => ({ ...counts, [id]: (counts[id] ?? 0) + 1 }));
    }
  };
  return { clearCounts, noteWrite };
};
